export default __webpack_public_path__ + "static/media/Reports.LineChart.bbb55277.svg";